import React, { useContext } from "react"

import { Core, Marketing, MarketingEnterprise, MarketingExpertNew, Support, SupportEnterprise } from "@features/Price/Panel/Tariff/Tariffs"
import { useHeaderVisibility } from "@features/Price/Panel/useHeaderVisibility"

import Range from "../Range"
import Discount from "../Discount"
import { useScrollFixed } from "../useScrollFixed"
import { PriceContext } from "../../PriceContext"

import * as styles from "./style.module.scss"

const PanelFixed: React.FC = () => {
  const isFixed = useScrollFixed("fixed_sentinel", 100, "modules-block")
  useHeaderVisibility(isFixed)

  const { team } = useContext(PriceContext)
  const blocks = blocksByTeam[team] || marketingBlocks

  return (
    <div className={`${styles.fixedPanel} ${isFixed ? styles.fixedPanelActive : ""}`}>
      <div className={styles.fixedPanelRow}>
        <div className={styles.fixedPanelSidebar}>
          <Range fixed />
          <Discount />
        </div>

        {blocks.map(({ render }, index) => (
          <div key={index} className={`${styles.fixedPanelColumn}`}>
            {render()}
          </div>
        ))}
      </div>
    </div>
  )
}

export default PanelFixed

const marketingBlocks = [
  { render: () => <Marketing show={false} /> },
  { render: () => <MarketingExpertNew show={false} /> },
  { render: () => <MarketingEnterprise show={false} /> },
]

const supportBlocks = [
  { render: () => <Core show={false} /> },
  { render: () => <Support show={false} /> },
  { render: () => <SupportEnterprise show={false} /> },
]

const blocksByTeam = {
  marketing: marketingBlocks,
  support: supportBlocks,
} as const
